class Elementor_Menu_Service{
    static instance;

    static getInstance() {
        if (!Elementor_Menu_Service.instance) {
            Elementor_Menu_Service.instance = new Elementor_Menu_Service();
        }
        return Elementor_Menu_Service.instance;
    }

    constructor(){
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init(){
        elementorFrontend.hooks.addAction( 'frontend/element_ready/opal-menu_carousel.default', ( $scope ) => {
            let $carousel = $scope.find('.owl-carousel');
            if($carousel.length > 0){
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }

        } );
    }
}


Elementor_Menu_Service.getInstance();